import AdviserProfilesApi from '../../../../../core/api/AdviserProfilesApi'
import PendingApprovalAdviserProfilesApi from '../../../../../core/api/PendingApprovalAdviserProfilesApi'
import { toast } from 'react-toastify'

export const events = {
  submitting: {
    rejectProfile: 'SUBMITTING_REJECT_PROFILE'
  },
  submitted: {
    rejectProfile: 'SUBMITTED_REJECT_PROFILE'
  },
  submit: {
    rejectProfile: 'SUBMIT_REJECT_PROFILE'
  }
}

const api = new AdviserProfilesApi()
const pendingApprovalAdviserProfilesApi = new PendingApprovalAdviserProfilesApi()

export const submittingProfileForApproval = () => ({
  type: events.submitted.rejectProfile
})

export function rejectProfile (adviserId) {
  const request = pendingApprovalAdviserProfilesApi.rejectProfile(adviserId)
  return (dispatch) => {
    dispatch(submittingProfileForApproval())
    toast.info('Profile Rejected', {
          autoClose: 10000
        })
    request.then(function (response) {
      dispatch(api.handleResponse(events.submit.rejectProfile, response))
    })
  }
}
